import React, { useState, useEffect } from 'react';
import axios from 'axios';
import DOMPurify from 'dompurify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTag } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import './OfferSection.css';

// Shows only when there is at least one offer in the database; otherwise renders nothing.
const OfferSection = () => {
  const [offers, setOffers] = useState([]);

  useEffect(() => {
    let cancelled = false;
    const fetchOffers = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/getoffersection`);
        if (!cancelled && Array.isArray(response.data)) setOffers(response.data);
      } catch (err) {
        // no offers shown if the API fails
      }
    };
    fetchOffers();
    return () => {
      cancelled = true;
    };
  }, []);

  if (offers.length === 0) return null;

  const whatsappFor = (title) =>
    `https://api.whatsapp.com/send/?phone=${process.env.REACT_APP_MOBILE_NUMBER1}&text=${encodeURIComponent(
      `Hi! I'm interested in the offer: ${title}`
    )}&type=phone_number&app_absent=0`;

  return (
    <section className="rmoff" aria-label="Current offers">
      <div className="rmoff-inner">
        {offers.map((offer, index) => (
          <article key={offer.Id ?? offer.id ?? index} className="rmoff-card">
            {offer.Img && (
              <div className="rmoff-media">
                <img
                  src={`${process.env.REACT_APP_API_BASE_URL1}/assets/img/offers/${offer.Img}`}
                  alt={offer.Title || 'Current offer'}
                  loading="lazy"
                />
              </div>
            )}

            <div className="rmoff-content">
              <span className="rmoff-tag">
                <FontAwesomeIcon icon={faTag} />
                Limited offer
              </span>
              <h2 className="rmoff-title">{offer.Title}</h2>
              {offer.Details && (
                <div
                  className="rmoff-details"
                  dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(offer.Details) }}
                />
              )}
              <a
                href={whatsappFor(offer.Title || 'current offer')}
                target="_blank"
                rel="noopener noreferrer"
                className="rmoff-btn"
              >
                <FontAwesomeIcon icon={faWhatsapp} />
                Claim this offer
              </a>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default OfferSection;